import React from "react";
import Tilt from "react-parallax-tilt";
import { Container, Row, Col } from "react-bootstrap";
import {
  AiFillGithub,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { usePortfolioSettings } from "../../hooks/usePortfolioData";
import { useSocialLinks } from "../../hooks/usePortfolioData";

function Home2() {
  const { settings } = usePortfolioSettings();
  const { socialLinks } = useSocialLinks();
  const [imageKey, setImageKey] = React.useState(0);

  // Settings are already loaded by the hook, no need to refetch

  // Determine the image to use - handle null, undefined, and empty string
  const homeAboutImage = React.useMemo(() => {
    const imageValue = settings?.home_about_image;
    // Check if it's null, undefined, or empty string
    if (!imageValue || (typeof imageValue === 'string' && imageValue.trim() === '')) {
      return '/Assets/about.png';
    }
    return imageValue;
  }, [settings?.home_about_image]);

  // Force image reload when image value changes
  React.useEffect(() => {
    setImageKey(prev => prev + 1);
  }, [homeAboutImage]);

  const homeName = settings?.home_name || 'Firas Bayoudhi';
  const homeLocation = settings?.home_location || 'Tunisia, and Currently resident in Brussels';
  const homeTitle = settings?.home_title || 'IoT Developer';
  const homeQuote = settings?.home_quote || 'Success is often achieved by those who don\'t know that failure is inevitable.';
  const homeQuoteAuthor = settings?.home_quote_author || 'Coco Chanel, fashion designer';

  // Social links with fallbacks
  const github = socialLinks?.github || 'https://github.com/bayoudhif';
  const linkedin = socialLinks?.linkedin || 'https://tn.linkedin.com/in/bayoudhi';
  const instagram = socialLinks?.instagram || 'https://www.instagram.com/bayoudhi.f/';

  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              <span className="purple"> KNOW WHO </span> I'M
            </h1>
            <p className="home-about-body">
            Hi Everyone, I am  <span className="purple">{homeName}</span> from &nbsp; 
              <span className="purple">{homeLocation}</span> <br />  <br />I am a junior <span className="purple">{homeTitle}.</span>
            <br />
            <br />
            Apart from IoT, I am passionate about <span className="purple">Web Development</span>  and <span className="purple">Artificial Intelligence.</span>
            </p>
            <p 
              style={{ color: "var(--quote-color, #5e87f5)" }}
              dangerouslySetInnerHTML={{ __html: `"${homeQuote}"` }}
            />
            <footer className="blockquote-footer">{homeQuoteAuthor}</footer>

          </Col>
          <Col md={3} className="myAvtar">
            <Tilt>
              <img 
                key={`home-about-${imageKey}-${homeAboutImage}`}
                src={`${homeAboutImage}?v=${imageKey}`}
                className="img-fluid" 
                alt="avatar"
                onError={(e) => {
                  const fallback = '/Assets/about.png';
                  if (!e.target.src.includes(fallback)) {
                    e.target.src = `${fallback}?v=${Date.now()}`;
                  }
                }}
                style={{ 
                  display: 'block'
                }}
              />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME <span className="purple">ON </span></h1>

            <ul className="home-about-social-links">
              {github && (
                <li className="social-icons">
                  <a
                    href={github}
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour  home-social-icons"
                  >
                    <AiFillGithub />
                  </a>
                </li>
              )}

              {linkedin && (
                <li className="social-icons">
                  <a
                    href={linkedin}
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour  home-social-icons"
                  >
                    <FaLinkedinIn />
                  </a>
                </li>
              )}
              {instagram && (
                <li className="social-icons">
                  <a
                    href={instagram}
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour home-social-icons"
                  >
                    <AiFillInstagram />
                  </a>
                </li>
              )}
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
